/**
 * Traduções dos textos fixos da interface.
 * O idioma é detectado via navigator.language do navegador.
 */

const translations = {
  'pt-BR': {
    adicionar: 'Adicionar',
    adicionado: 'Adicionado!',
    adicionando: 'Adicionando...',
    verCarrinho: 'Ver Carrinho',
    selecioneAcompanhamento: 'Selecione um acompanhamento',
    confirmarInclusao: 'Você realmente deseja incluir este item no carrinho?',
    erroAdicionar: '❌ Erro ao adicionar item. Tente novamente.',
    selecioneAdicionais: 'Selecione os adicionais:',
    buscar: 'Buscar...',
    todasCategorias: 'Todas as Categorias',
    servicos: 'Serviços',
    canaisTv: 'Canais de TV',
    abertoDas: 'Aberto das',
    whatsappSuporte: 'Suporte',
    whatsappDescricao: 'Para acionar o suporte técnico, você será direcionado para o App WhatsApp do seu celular.',
    whatsappPrivacidade: 'Seus dados pessoais não serão compartilhados com ninguém e nem o técnico tem acesso ao seu número de celular.',
    whatsappTermos: 'Ao continuar, você concorda com os',
    whatsappTermosLink: 'Termos de Uso',
    whatsappContinuar: 'Continuar',
    whatsappCancelar: 'Cancelar',
  },
  pt: {
    adicionar: 'Adicionar',
    adicionado: 'Adicionado!',
    adicionando: 'Adicionando...',
    verCarrinho: 'Ver Carrinho',
    selecioneAcompanhamento: 'Selecione um acompanhamento',
    confirmarInclusao: 'Você realmente deseja incluir este item no carrinho?',
    erroAdicionar: '❌ Erro ao adicionar item. Tente novamente.',
    selecioneAdicionais: 'Selecione os adicionais:',
    buscar: 'Buscar...',
    todasCategorias: 'Todas as Categorias',
    servicos: 'Serviços',
    canaisTv: 'Canais de TV',
    abertoDas: 'Aberto das',
    whatsappSuporte: 'Suporte',
    whatsappDescricao: 'Para acionar o suporte técnico, você será direcionado para o App WhatsApp do seu celular.',
    whatsappPrivacidade: 'Seus dados pessoais não serão compartilhados com ninguém e nem o técnico tem acesso ao seu número de celular.',
    whatsappTermos: 'Ao continuar, você concorda com os',
    whatsappTermosLink: 'Termos de Uso',
    whatsappContinuar: 'Continuar',
    whatsappCancelar: 'Cancelar',
  },
  en: {
    adicionar: 'Add',
    adicionado: 'Added!',
    adicionando: 'Adding...',
    verCarrinho: 'View Cart',
    selecioneAcompanhamento: 'Select a side dish',
    confirmarInclusao: 'Do you really want to add this item to the cart?',
    erroAdicionar: '❌ Error adding item. Please try again.',
    selecioneAdicionais: 'Select additional items:',
    buscar: 'Search...',
    todasCategorias: 'All Categories',
    servicos: 'Services',
    canaisTv: 'TV Channels',
    abertoDas: 'Open from',
    whatsappSuporte: 'Support',
    whatsappDescricao: 'To contact technical support, you will be redirected to the WhatsApp app on your phone.',
    whatsappPrivacidade: 'Your personal data will not be shared with anyone, and the technician does not have access to your phone number.',
    whatsappTermos: 'By continuing, you agree to the',
    whatsappTermosLink: 'Terms of Use',
    whatsappContinuar: 'Continue',
    whatsappCancelar: 'Cancel',
  },
  es: {
    adicionar: 'Agregar',
    adicionado: '¡Agregado!',
    adicionando: 'Agregando...',
    verCarrinho: 'Ver Carrito',
    selecioneAcompanhamento: 'Seleccione un acompañamiento',
    confirmarInclusao: '¿Realmente desea agregar este artículo al carrito?',
    erroAdicionar: '❌ Error al agregar el artículo. Inténtelo de nuevo.',
    selecioneAdicionais: 'Seleccione los adicionales:',
    buscar: 'Buscar...',
    todasCategorias: 'Todas las Categorías',
    servicos: 'Servicios',
    canaisTv: 'Canales de TV',
    abertoDas: 'Abierto de',
    whatsappSuporte: 'Soporte',
    whatsappDescricao: 'Para contactar con el soporte técnico, será redirigido a la aplicación WhatsApp de su teléfono.',
    whatsappPrivacidade: 'Sus datos personales no serán compartidos con nadie y el técnico no tiene acceso a su número de teléfono.',
    whatsappTermos: 'Al continuar, acepta los',
    whatsappTermosLink: 'Términos de Uso',
    whatsappContinuar: 'Continuar',
    whatsappCancelar: 'Cancelar',
  },
  fr: {
    adicionar: 'Ajouter',
    adicionado: 'Ajouté !',
    adicionando: 'Ajout en cours...',
    verCarrinho: 'Voir le Panier',
    selecioneAcompanhamento: 'Sélectionnez un accompagnement',
    confirmarInclusao: 'Voulez-vous vraiment ajouter cet article au panier ?',
    erroAdicionar: '❌ Erreur lors de l\'ajout. Veuillez réessayer.',
    selecioneAdicionais: 'Sélectionnez les suppléments :',
    buscar: 'Rechercher...',
    todasCategorias: 'Toutes les Catégories',
    servicos: 'Services',
    canaisTv: 'Chaînes TV',
    abertoDas: 'Ouvert de',
    whatsappSuporte: 'Support',
    whatsappDescricao: 'Pour contacter le support technique, vous serez redirigé vers l\'application WhatsApp de votre téléphone.',
    whatsappPrivacidade: 'Vos données personnelles ne seront partagées avec personne et le technicien n\'a pas accès à votre numéro de téléphone.',
    whatsappTermos: 'En continuant, vous acceptez les',
    whatsappTermosLink: 'Conditions d\'utilisation',
    whatsappContinuar: 'Continuer',
    whatsappCancelar: 'Annuler',
  },
  it: {
    adicionar: 'Aggiungi',
    adicionado: 'Aggiunto!',
    adicionando: 'Aggiungendo...',
    verCarrinho: 'Vedi Carrello',
    selecioneAcompanhamento: 'Seleziona un contorno',
    confirmarInclusao: 'Vuoi davvero aggiungere questo articolo al carrello?',
    erroAdicionar: '❌ Errore nell\'aggiunta. Riprova.',
    selecioneAdicionais: 'Seleziona gli extra:',
    buscar: 'Cerca...',
    todasCategorias: 'Tutte le Categorie',
    servicos: 'Servizi',
    canaisTv: 'Canali TV',
    abertoDas: 'Aperto dalle',
    whatsappSuporte: 'Supporto',
    whatsappDescricao: 'Per contattare il supporto tecnico, verrai reindirizzato all\'app WhatsApp del tuo telefono.',
    whatsappPrivacidade: 'I tuoi dati personali non saranno condivisi con nessuno e il tecnico non ha accesso al tuo numero di telefono.',
    whatsappTermos: 'Continuando, accetti i',
    whatsappTermosLink: 'Termini di utilizzo',
    whatsappContinuar: 'Continua',
    whatsappCancelar: 'Annulla',
  },
  zh: {
    whatsappSuporte: '支持',
    whatsappDescricao: '如需联系技术支持，您将被引导至手机上的 WhatsApp 应用。',
    whatsappPrivacidade: '您的个人数据不会与任何人共享，技术人员也无法访问您的电话号码。',
    whatsappTermos: '继续操作即表示您同意',
    whatsappTermosLink: '使用条款',
    whatsappContinuar: '继续',
    whatsappCancelar: '取消',
  },
  ja: {
    whatsappSuporte: 'サポート',
    whatsappDescricao: 'テクニカルサポートに連絡するには、携帯電話のWhatsAppアプリに移動します。',
    whatsappPrivacidade: '個人情報が第三者と共有されることはなく、担当者が電話番号にアクセスすることもありません。',
    whatsappTermos: '続行すると、以下に同意したものとみなされます：',
    whatsappTermosLink: '利用規約',
    whatsappContinuar: '続行',
    whatsappCancelar: 'キャンセル',
  },
};

/**
 * Retorna o idioma base (ex: "pt-BR" → "pt", "en-US" → "en")
 */
const getBaseLanguage = (fallback = 'pt-BR') => {
  const lang = navigator.language || navigator.userLanguage || 'pt-BR';
  // Tenta primeiro o idioma completo (pt-BR), depois só o prefixo (pt)
  if (translations[lang]) return lang;
  const base = lang.split('-')[0];
  if (translations[base]) return base;
  return fallback;
};

/** Tradução com fallback independente para componentes específicos. */
export const tWithFallback = (key, fallbackLanguage = 'en') => {
  const browserLanguage = navigator.language || navigator.userLanguage || '';
  const baseLanguage = browserLanguage.split('-')[0].toLowerCase();
  const supportedLanguages = ['pt', 'en', 'fr', 'es', 'it', 'zh', 'ja'];
  const lang = supportedLanguages.includes(baseLanguage)
    ? baseLanguage
    : fallbackLanguage;
  return translations[lang]?.[key] || translations[fallbackLanguage]?.[key] || key;
};

/**
 * Retorna a tradução para uma chave específica.
 * @param {string} key - Chave de tradução
 * @returns {string} Texto traduzido
 */
export const t = (key) => {
  const lang = getBaseLanguage();
  return translations[lang]?.[key] || translations['pt-BR'][key] || key;
};

export default translations;
